export default "__VITE_ASSET__BoU68Mvj__"